<ngx-spinner></ngx-spinner>
<div
  class="detail-box"
  [ngClass]="isActive || myAccountService.isActive ? 'active-mobile' : ''"
>
  <div
    class="position-relative"
    *ngIf="is_data == 'yes' && result?.canceled_at == null"
  >
    <div
      class="mobile_head d-flex align-items-start justify-content-between flex-wrap"
    >
      <div class="d-flex align-items-center mb-2">
        <a href="JavaScript:void(0)" (click)="remove()" class="back_link">
          <span class="icon-arrow-left"></span>
        </a>
        <h4>{{ "SUBSCRIPTION_INFO.SUBSCRIPTION" | translate }}</h4>
      </div>
      <button (click)="cancelPlane()" type="button" class="btn btn-danger">
        {{ "SUBSCRIPTION_INFO.CANCEL_BUTTON" | translate }}
      </button>
    </div>
    <div class="row m-0">
      <div class="head-date">
        <div
          class="mb-0 text-white d-flex align-items-start flex-wrap"
          *ngIf="result?.start_date"
        >
          {{ "SUBSCRIPTION_INFO.SUBSCRIPTION_DATE" | translate }}

          <p class="mb-0 pl-2">
            {{ result?.start_date * 1000 | date: "mediumDate" }}
          </p>
        </div>

        <div
          class="mb-0 text-white d-flex align-items-start flex-wrap"
          *ngIf="result?.current_period_end"
        >
          {{ "SUBSCRIPTION_INFO.SUBSCRIPTION_INVOICE_DATE" | translate }}

          <p class="mb-0 pl-2">
            {{ result?.current_period_end * 1000 | date: "mediumDate" }}
          </p>
        </div>
        <div
          class="mb-0 text-white d-flex align-items-start flex-wrap"
          *ngIf="result?.discount"
        >
          {{ "SUBSCRIPTION_INFO.SUBSCRIPTION_COUPON_USED" | translate }}

          <p class="mb-0 pl-2">
            {{ result?.discount.coupon.name }}
          </p>
        </div>
        <div
          *ngIf="result?.next_amount"
          class="mb-0 text-white d-flex align-items-start flex-wrap"
        >
          {{ "SUBSCRIPTION_INFO.SUBSCRIPTION_NEXT_AMOUNT" | translate }}

          <p class="mb-0 pl-2">${{ result?.next_amount }}</p>
        </div>
      </div>
      <div class="plan-box1">
        <div class="w-100" *ngFor="let plan of subscription; let i = index">
          <div
            class="plans-content"
            *ngIf="
              (plan.type | translate | lowercase).split(' ')[0] ==
              (result.subscription_type | lowercase)
            "
          >
            <p class="mb-0 plan-batch btn btn-theme">
              {{ plan.type | translate }}
            </p>
            <div class="d-flex w-100 plan-data">
              <!-- <i class="mdi mdi-calendar-outline"></i> -->
              <h1>
                <p class="mb-0">
                  <b *ngIf="result.discount_value !== 'FREE'">$</b
                  >{{
                    result.discount_value
                      ? result.discount_value === "FREE"
                        ? result.discount_value
                        : (result.discount_value | decimalNumber)
                      : plan.price
                  }}
                </p>
              </h1>
              <ul>
                <li *ngFor="let feature of plan.description.feature">
                  {{ feature | translate }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
  <div class="" *ngIf="is_data == 'no'">
    <div class="plan-box">
      <div class="m-auto" style="max-width: 230px">
        <img src="assets/images/error-paln.png" class="w-100" />
      </div>
      <a [routerLink]="['/home/subscription']"> </a>
      <p class="mt-3">
        {{ "SUBSCRIPTION_INFO.MESSAGE" | translate }}
        <a class="text-primary" [routerLink]="['/subscription']">{{
          "SUBSCRIPTION_INFO.CLICK_TO_SUBSCRIBE" | translate
        }}</a>
      </p>
    </div>
  </div>
  <div class="plan-history" *ngIf="subscriptionData.length > 0">
    <div class="mobile_head p-0 mb-3">
      <h4>{{ "SUBSCRIPTION_INFO.PLAN_HISTORY" | translate }}</h4>
    </div>
    <div class="history-box table-responsive">
      <table>
        <thead>
          <th>{{ "SUBSCRIPTION_INFO.PLAN" | translate }}</th>
          <!-- <th>{{ "SUBSCRIPTION_INFO.PRICE" | translate }}</th> -->

          <th>{{ "SUBSCRIPTION_INFO.PRICE" | translate }}</th>
          <th style="min-width: 110px">
            {{ "SUBSCRIPTION_INFO.RENEW_DATE" | translate }}
          </th>
          <th>{{ "SUBSCRIPTION_INFO.STATUS" | translate }}</th>
          <th>{{ "SUBSCRIPTION_INFO.PURCHASE_FROM" | translate }}</th>
        </thead>
        <tbody>
          <tr *ngFor="let plan of subscriptionData">
            <td>
              <div *ngFor="let data of subscription">
                <div
                  *ngIf="
                    data.plan_id === plan.plan ||
                    data.google_plan_id === plan.plan ||
                    data.apple_plan_id === plan.plan
                  "
                >
                  {{ data.type | translate | uppercase }}
                </div>
              </div>
            </td>
            <!-- <td>${{ plan.amount }}</td> -->
            <td>
              <span
                *ngIf="plan.discount_amount"
                style="text-decoration: line-through"
                >${{ plan.amount }}</span
              >
              <span
                *ngIf="
                  plan.amount - plan.discount_amount != 0 &&
                  plan.discount_amount < plan.amount
                "
                >$</span
              >
              <span>{{
                plan.discount_amount
                  ? plan.amount - plan.discount_amount == 0 ||
                    plan.discount_amount >= plan.amount
                    ? "FREE"
                    : (plan.amount - plan.discount_amount | decimalNumber)
                  : plan.amount
              }}</span>
            </td>
            <td>
              {{ plan.renew_date | date }}
            </td>
            <td class="status">
              <span class="{{ plan.status }}">
                {{ plan.status | titlecase }}
              </span>
            </td>
            <td>
              <span>
                {{ plan.payment_gateway | titlecase }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
